/* eslint-disable no-param-reassign */
import { Crop } from 'react-image-crop';

export const cropImage = async (
  image: HTMLImageElement,
  crop: Crop,
  canvas: HTMLCanvasElement,
) => {
  if (!image) return;
  const ctx = canvas.getContext('2d');
  if (!ctx) {
    throw new Error('No 2d context');
  }
  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;
  const width = crop.width * scaleX;
  const height = crop.height * scaleX;
  canvas.width = Math.floor(width);
  canvas.height = Math.floor(height);
  const cropX = crop ? crop.x * scaleX : 0;
  const cropY = crop ? crop.y * scaleY : 0;
  const centerX = image.naturalWidth / 2;
  const centerY = image.naturalHeight / 2;
  ctx.save();
  // 5) Move the crop origin to the canvas origin (0,0)
  ctx.translate(-cropX, -cropY);
  // 4) Move the origin to the center of the original position
  ctx.translate(centerX, centerY);
  // 1) Move the center of the image to the origin (0,0)
  ctx.translate(-centerX, -centerY);
  ctx.drawImage(
    image,
    0,
    0,
    image.naturalWidth,
    image.naturalHeight,
    0,
    0,
    image.naturalWidth,
    image.naturalHeight,
  );
  ctx.restore();
  const blob = await toBlob(canvas);
  if (blob) {
    return { blob, url: URL.createObjectURL(blob) };
  }
  return undefined;
};

const toBlob = (canvas: HTMLCanvasElement) =>
  new Promise<Blob | null>((resolve) => {
    canvas.toBlob((file) => {
      resolve(file);
    }, 'image/jpeg');
  });
